module.exports = __webpack_public_path__ + "img/stock1.46bca526.png";